import { cn } from '@/app/lib/utils';
import { ScrollThumbProps } from '../scrollbar.types';

export function ScrollThumb({
  orientation,
  className,
  scrollAreaId,
  ariaNow,
  ariaMax,
  thumbRef,
  onMouseDown,
}: ScrollThumbProps) {
  const baseClasses =
    orientation === 'vertical'
      ? 'pointer-events-auto absolute left-0 right-0 mx-auto rounded-full cursor-pointer will-change-transform'
      : 'pointer-events-auto absolute top-0 bottom-0 my-auto rounded-full cursor-pointer will-change-transform';

  return (
    <div
      ref={thumbRef}
      role="scrollbar"
      aria-orientation={orientation}
      aria-controls={scrollAreaId}
      aria-valuemin={0}
      aria-valuenow={ariaNow}
      aria-valuemax={ariaMax}
      onMouseDown={onMouseDown}
      className={cn(baseClasses, 'bg-primary', className)}
      style={{ transform: 'translate3d(0,0,0)' }}
    />
  );
}
